/*
 * @Author: gang.liu
 * @Date: 2021-06-29 14:14:35
 * @LastEditTime: 2021-06-29 14:15:17
 * @LastEditors: gang.liu
 * @Description: homeRoute
 * @api-property: 
 * @api-event: 
 * @api-method: 
 */
import { MainLayout } from "@/layout";
import { homeRoute } from "@/config/RouteConfig";

const home = {
  path: "",
  component: MainLayout,
  children: [
    {
      ...homeRoute,
      component: () => import("@/views/Home"),
    },
  ],
};

export default home;
